export default __webpack_public_path__ + "static/media/philips.b6970cab.png";